<template>
  <div class="Sbzcbox">
    <SBZC />
  </div>
</template>
<script>
import SBZC from "@/components/SBZC.vue";
export default {
  components: { SBZC },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.Sbzcbox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-color: #efefef;
  overflow-y: scroll;
}
</style>